export const NARRATIVE_LABEL_AUTOMATIC = "automatic";
